import React, { useState } from 'react'
import { CircularProgress, IconButton } from '@material-ui/core'
import Icon from '../../../../../components/icon/Icon'
import iconsEnum from '../../../../../enums/iconsEnum'
import makeStyles from '@material-ui/core/styles/makeStyles'
import styles from '../../../../../styles'
import { ModelDoc } from '../docs_model'
import { IntlShape, useIntl } from 'react-intl'
import { downloadPDF } from '../documentMapper'

const useStyle = makeStyles((theme) => ({
        ...styles(theme),
        iconPdf: {
            fill: theme.palette.accessibility.main
        }
    }
))

interface AcceptingProps {
    doc: ModelDoc
}

type DocPdfProps = AcceptingProps

const DocPdf: React.FC<DocPdfProps> = (
    {
        doc
    }
) => {
    const classes = useStyle()
    const intl: IntlShape = useIntl()
    const [loadingDdl, setLoadingDdl] = useState<boolean>(false)

    return (
        <IconButton onClick={() => downloadPDF(doc, intl.locale, setLoadingDdl)}>
            {loadingDdl ?
                <CircularProgress size={24} />
                :
                <Icon size={24} icon={iconsEnum.Pdf} className={classes.iconPdf} />
            }
        </IconButton>
    )
}

export default DocPdf